import { DASHBOARD } from '_constants';
import { fetchMember } from '../services/member.services';

const initialize = () => (dispatch, getState) => {
  dispatch({ type: DASHBOARD.FETCH_DASHBOARD_DATA, value: '' });
};

const getMember = (memberKey) => async (dispatch) => {
  dispatch({ type: DASHBOARD.START_MEMBER_FETCH });
  try {
    const response = await dispatch(fetchMember(memberKey));
    dispatch({
      type: DASHBOARD.FETCH_MEMBER_DATA,
      payload: response
    });
    return response;
  } catch (err) {
    console.error(err);
    return Promise.reject(err);
  } finally {
    dispatch({ type: DASHBOARD.END_MEMBER_FETCH });
  }
};

export const dashboardActions = {
  initialize,
  getMember
};
